"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpertNetworkEmails = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var getExpertNetworkEmails = function (expertId) {
    return api_1.default
        .get("".concat(process.env.REACT_APP_PLATFORM_2_API_URL, "/expert-network/email/getEmails?expertId=").concat(expertId, "&expertSourceFromLP=true"))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
};
exports.getExpertNetworkEmails = getExpertNetworkEmails;
